import { Loader2 } from 'lucide-react';

/**
 * Loading skeleton for lazy-loaded sections
 * Shows a centered spinner with optional message
 */
export function SectionLoader({ message = 'Loading...' }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 min-h-[300px]" data-testid="section-loader">
      <Loader2 className="h-8 w-8 animate-spin text-primary mb-4" />
      <p className="text-sm text-muted-foreground">{message}</p>
    </div>
  );
}

/**
 * Card skeleton for content grids
 */
export function CardSkeleton({ count = 4 }) {
  return (
    <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
      {Array(count).fill(0).map((_, i) => (
        <div key={i} className="p-4 rounded-lg bg-card border animate-pulse">
          <div className="h-4 bg-muted rounded w-1/3 mb-3" />
          <div className="h-4 bg-muted rounded w-3/4 mb-2" />
          <div className="h-3 bg-muted rounded w-1/2" />
        </div>
      ))}
    </div>
  );
}

/**
 * Video grid skeleton
 */
export function VideoSkeleton({ count = 4 }) {
  return (
    <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
      {Array(count).fill(0).map((_, i) => (
        <div key={i} className="rounded-lg overflow-hidden border animate-pulse">
          <div className="aspect-video bg-muted" />
          <div className="p-3">
            <div className="h-4 bg-muted rounded w-3/4 mb-2" />
            <div className="h-3 bg-muted rounded w-1/2" />
          </div>
        </div>
      ))}
    </div>
  );
}
